<template>
  <div>
    <md-card class="graduation">
      <md-card-header class="md-card-header-text md-card-header-green pl-2">
        <div class="card-text">
          <p class="title text-lg">
            {{ $t("student.graduation") }}
          </p>
        </div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout pl-3">
          <div class="md-layout-item md-size-100 pt-2 pb-2">
            <p>{{ $t("student.date_awarded") }}</p>
          </div>
          <div
            class="
              md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100
            "
          >
            <date-picker-custom
              :disabled="!allowUpdate"
              :label="$t('student.date_first_entered_the_9th_grade')"
              v-model="form.date_first_entered_the_9th_grade"
            >
            </date-picker-custom>
          </div>
          <div
            class="
              md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100
            "
          >
            <date-picker-custom
              :disabled="!allowUpdate"
              :label="$t('student.diploma_date')"
              v-model="form.diploma_date"
            >
            </date-picker-custom>
          </div>
          <div
            class="
              md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100
            "
          >
            <md-field>
              <label>{{ $t("student.diploma_type") }}</label>
              <md-input
                v-model="form.diploma_type"
                :disabled="!allowUpdate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <p>{{ $t("student.district_defined_graduation_fields") }}</p>
          </div>
          <div class="md-layout-item md-size-100">
            <md-checkbox v-model="isLockComment" :disabled="!allowUpdate"
              >{{ $t("student.lock_ends_seals_certs") }}:</md-checkbox
            >
          </div>
          <div class="md-layout-item md-size-100 pb-3">
            <p>{{ $t("student.lock_comment") }}</p>
          </div>
          <div
            class="md-layout-item md-size-100 pl-0"
            :class="{ 'bg-[#D8D8D8]': isLockComment }"
            style="border: 1px solid #ccc"
          >
            <md-field>
              <md-textarea
                :disabled="isLockComment || !allowUpdate"
                v-model="form.comment"
              ></md-textarea>
            </md-field>
          </div>

          <!--      graduation Award Information    -->
          <div class="md-layout-item md-size-100 pt-3 pb-3">
            {{ $t("student.graduation_award_information") }}
          </div>
          <div
            class="pb-2 w-full"
            v-for="(award, index) in form.graduation_award_information"
            :key="'award' + index"
          >
            <div class="md-layout">
              <div class="md-layout-item md-size-90 pl-0">
                <div class="md-layout">
                  <div
                    class="
                      md-layout-item
                      md-size-33
                      md-medium-size-50
                      md-xsmall-size-100
                    "
                  >
                    <date-picker-custom
                      :disabled="!allowUpdate"
                      v-model="award.date_awarded"
                      :label="$t('student.date_awarded')"
                    >
                      <span
                        class="md-error"
                        v-if="serverValidations.end_date"
                        >{{ serverValidations.end_date }}</span
                      >
                    </date-picker-custom>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-size-33
                      md-medium-size-50
                      md-xsmall-size-100
                    "
                  >
                    <md-field>
                      <label>{{ $t("student.award") }}</label>
                      <md-input
                        v-model="award.award"
                        :disabled="!allowUpdate"
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-size-33
                      md-medium-size-50
                      md-xsmall-size-100
                    "
                  >
                    <md-field>
                      <label>{{ $t("student.award_type") }}</label>
                      <md-input
                        v-model="award.award_type"
                        :disabled="!allowUpdate"
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="
                      md-layout-item
                      md-size-33
                      md-medium-size-50
                      md-xsmall-size-100
                    "
                  >
                    <md-field>
                      <label>{{ $t("student.award_detail") }}</label>
                      <md-input
                        v-model="award.award_detail"
                        :disabled="!allowUpdate"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
              </div>
              <div
                v-if="index !== 0"
                class="md-layout-item md-size-5 text-center pt-7 cursor-pointer"
                @click.prevent="deleteAward(index)"
              >
                <md-icon class="text-red-600">delete</md-icon>
              </div>
            </div>
          </div>
          <div class="md-size-100 pb-5 pl-4" v-if="allowUpdate">
            <a class="cursor-pointer" @click.prevent="addAward">{{
              $t("student.add_award")
            }}</a>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div
      class="form-actions flex w-full justify-center pb-8"
      v-if="allowUpdate"
    >
      <md-button class="md-raised mr-2" @click="goToPreviousPage">
        {{ $t("common.cancel") }}
      </md-button>
      <md-button @click="updateGraduation" class="md-success">{{
        $t("common.update")
      }}</md-button>
    </div>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";
import { Message, hasHistory } from "@/helpers/utils";
import { Student } from "@/constants/Permissions";
import pick from "lodash/pick";
import moment from "moment";
import { ISIS_FORMAT } from "@/helpers/datetime-helper";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import { mapGetters } from "vuex";

const defaultForm = () => {
  return {
    date_first_entered_the_9th_grade: null,
    diploma_date: null,
    diploma_type: "",
    comment: "",
    graduation_award_information: [
      {
        date_awarded: null,
        award: "",
        award_type: "",
        award_detail: ""
      }
    ]
  };
};
export default {
  data() {
    return {
      studentId: this.$route.params.id,
      serverValidations: "",
      isLockComment: true,
      Student,
      form: defaultForm(),
      isActive: false
    };
  },
  props: ["isActiveTab"],
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    allowUpdate() {
      return (
        !hasValidRole(this.userRole, [
          Role.Student,
          Role.Family,
          Role.Counselor,
          Role.Teacher
        ]) && this.$can(Student.actions.edit, Student.subject)
      );
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.fetchGraduation();
        this.isActive = true;
      }
    },
    "form.date_first_entered_the_9th_grade": function(newVal) {
      this.setDiplomaDate(newVal);
    },
    "form.diploma_date": function(newVal) {
      this.setDateFirstEntered(newVal);
    }
  },
  methods: {
    setDiplomaDate(selectedDate) {
      if (!selectedDate) {
        this.form.diploma_date = null;
        return;
      }
      const date = new Date(selectedDate);
      date.setFullYear(date.getFullYear() + 4);
      const diplomaDate = moment(date).format(ISIS_FORMAT.date);
      this.form.diploma_date = diplomaDate;
    },
    setDateFirstEntered(selectedDate) {
      if (!selectedDate) {
        this.form.date_first_entered_the_9th_grade = null;
        return;
      }
      const date = new Date(selectedDate);
      date.setFullYear(date.getFullYear() - 4);
      const dateFirstEntered = moment(date).format(ISIS_FORMAT.date);
      this.form.date_first_entered_the_9th_grade = dateFirstEntered;
    },
    addAward() {
      this.form.graduation_award_information.push({
        date_awarded: null,
        award: "",
        award_type: "",
        award_detail: ""
      });
    },
    deleteAward(index) {
      this.form.graduation_award_information.splice(index, 1);
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    fetchGraduation() {
      this.$axios
        .get(`${service_names.school}/graduation/${this.studentId}`)
        .then(response => {
          if (Object.keys(response.data).length === 0) {
            return;
          }
          this.form = pick(response.data, Object.keys(defaultForm()));
          if (
            this.form.graduation_award_information === null ||
            this.form.graduation_award_information?.length === 0
          ) {
            this.form.graduation_award_information = [
              {
                date_awarded: null,
                award: "",
                award_type: "",
                award_detail: ""
              }
            ];
          }
        });
    },
    filterData(form) {
      const graduation_award_information = form.graduation_award_information.filter(
        graduation => {
          let isValueExist = Object.values(graduation).some(item => !!item);
          if (isValueExist) return graduation;
        }
      );
      return { ...form, graduation_award_information };
    },
    updateGraduation() {
      const form = this.filterData(this.form);
      this.$axios
        .put(
          `${service_names.school}/graduation/${this.studentId}/update`,
          form
        )
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.fetchGraduation();
        });
    }
  }
};
</script>
<style lang="scss"></style>
